import * as React from 'react'

import { LOCIZE_NAMESPACE } from 'main/common'
import { useWhitelabel } from 'main/framework'
import { useTranslation } from 'react-i18next'
import { FilterControl } from '../common'
import IFullSearchProps from '../types'
import FilterForm from './FilterForm'
import { label } from './labelV2'

export default function NetworkRatingFilterV2(props: IFullSearchProps) {
  const {
    filters,
    displayForm,
    palette,
    onChangeFilters,
    onRequestCloseForm,
    onRequestDisplayForm,
  } = props

  const { t } = useTranslation(LOCIZE_NAMESPACE)

  const selectedNetworkRatings = filters.selectedNetworkRatingsV2.sort()
  const isActive = !!selectedNetworkRatings.length

  const whitelabel = useWhitelabel()
  const networkRatingData = whitelabel.networkRatingData()
  const ratingSystemTitle =
    networkRatingData.ratingSystemTitle && t(networkRatingData.ratingSystemTitle)
  const displayLabel = label(filters.selectedNetworkRatingsV2, ratingSystemTitle)

  return (
    <div>
      <FilterControl
        isActive={isActive}
        label={displayLabel}
        displayForm={displayForm}
        palette={palette}
        onRequestCloseForm={onRequestCloseForm}
        onRequestDisplayForm={onRequestDisplayForm}
        filterForm={
          <FilterForm
            filters={filters}
            onChangeFilters={onChangeFilters}
            onRequestCloseForm={onRequestCloseForm}
          />
        }
      />
    </div>
  )
}
